<script>
import Button from '@/components/v3/base/Button';
import Typography from '@/components/v3/base/Typography';
import HomeVideo from '@/assets/videos/home-animation.mp4';
import ClickUpLogo from '@/assets/icons/logo-clickup.svg';
import LogoEarnest from '@/assets/icons/logo-earnest.svg';
import LogoG2 from '@/assets/icons/logo-g2.svg';
import LogoIndeed from '@/assets/icons/logo-indeed.svg';
import LogoJLL from '@/assets/icons/logo-jll.svg';
import LogoLob from '@/assets/icons/logo-lob.svg';
import LogoLyft from '@/assets/icons/logo-lyft.svg';
import LogoSigma from '@/assets/icons/logo-sigma.svg';
import ZendeskLogo from '@/assets/icons/zendesk_logo2.svg';

export default {
  name: 'HomeBanner',
  components: {
    Button,
    Typography,
  },

  data() {
    return {
      HomeVideo,
      ClickUpLogo,
      LogoEarnest,
      LogoG2,
      LogoIndeed,
      LogoJLL,
      LogoLob,
      LogoLyft,
      LogoSigma,
      ZendeskLogo,
    };
  },

  methods: {
    onOpenDemoVideo() {
      this.$emit('open-demo-video');
    },
  },
};
</script>
<template>
  <div class="tw-bg-purple-500 tw-px-6">
    <div
      class="tw-max-w-container-1 tw-mx-auto md:tw-flex tw-justify-center tw-items-center tw-py-2 tw-text-white tw-gap-8"
    >
      <div class="tw-text-center tw-py-20">
        <Typography variant="headline-3">
          Sourcing sucks. <br />
          Let AI do it for you.
        </Typography>
        <div class="tw-mt-6 md:tw-flex tw-gap-6 tw-items-center">
          <div>
            <a href="/contact">
              <Button size="large" variant="white">Request a 1:1 demo</Button>
            </a>
          </div>
          <div>
            <Button
              variant="text"
              class="hover:tw-text-white"
              @click="onOpenDemoVideo"
              >or watch
              <span
                class="tw-border-0 tw-border-b-2 tw-border-solid tw-border-white"
                >the demo (1:30)
              </span>
            </Button>
          </div>
        </div>
      </div>
    </div>
    <div class="tw-max-w-container-1 tw-mx-auto video-container">
      <video autoplay loop muted class="responsive-video">
        <source :src="HomeVideo" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
    <div
      class="tw-max-w-container-1 tw-mx-auto tw-relative tw-overflow-hidden tw-py-2"
    >
      <div class="logo-track tw-flex tw-items-center tw-gap-20 tw-py-20">
        <div>
          <img :src="ClickUpLogo" alt="ClickUp" />
        </div>
        <div>
          <img :src="LogoEarnest" alt="Earnest" />
        </div>
        <div>
          <img :src="LogoG2" alt="G2" />
        </div>
        <div>
          <img :src="LogoIndeed" alt="Indeed" />
        </div>
        <div>
          <img :src="LogoJLL" alt="JLL" />
        </div>
        <div>
          <img :src="LogoLob" alt="Lob" />
        </div>
        <div>
          <img :src="LogoLyft" alt="Lyft" />
        </div>
        <div>
          <img :src="LogoSigma" alt="Sigma" />
        </div>
        <div>
          <img :src="ZendeskLogo" alt="Zendesk" class="tw-h-10" />
        </div>
      </div>
      <div
        class="logo-track2 tw-flex tw-items-center tw-gap-20 tw-py-20 tw-absolute tw-left-0 tw-top-0 tw-w-full tw-h-full"
      >
        <div>
          <img :src="ClickUpLogo" alt="ClickUp" />
        </div>
        <div>
          <img :src="LogoEarnest" alt="Earnest" />
        </div>
        <div>
          <img :src="LogoG2" alt="G2" />
        </div>
        <div>
          <img :src="LogoIndeed" alt="Indeed" />
        </div>
        <div>
          <img :src="LogoJLL" alt="JLL" />
        </div>
        <div>
          <img :src="LogoLob" alt="Lob" />
        </div>
        <div>
          <img :src="LogoLyft" alt="Lyft" />
        </div>
        <div>
          <img :src="LogoSigma" alt="Sigma" />
        </div>
        <div>
          <img :src="ZendeskLogo" alt="Zendesk" class="tw-h-10" />
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.video-container {
  width: 100%;
  aspect-ratio: 2264 / 1194; /* Maintains the correct aspect ratio */
}

.responsive-video {
  width: 100%;
  height: auto; /* Ensures auto-scaling */
  display: block;
}
.logo-track {
  animation: scroll 100s linear infinite;
  width: 1450px;
}
.logo-track2 {
  animation: scroll2 100s linear infinite;
  width: 1450px;
}
@keyframes scroll {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-1450px);
  }
}
@keyframes scroll2 {
  from {
    transform: translateX(1450px);
  }
  to {
    transform: translateX(0);
  }
}
</style>
